import { Ng2StateDeclaration, Resolvable, StateService, Transition } from '@uirouter/angular';
import { Observable } from 'rxjs';
import { ReportLibraryDataService } from '../reports/data-access/report-library-data.service';
import { UserGuideComponent } from './user-guide/user-guide.component';




/**
 * This state allows the user to set their application preferences
 */

 
export const userguideHomeState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuide',
    url: '/userguide',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
                trans.params(),
            deps: [Transition],
        }
    ]
};

export const userguideHomePageState: Ng2StateDeclaration = {
    name: 'userGuide.page',
    url: '/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
                trans.params(),
            deps: [Transition],
        }
    ]
}; 

export const userguideSectionHomeState: Ng2StateDeclaration = {
    name: 'userGuide.section',
    url: '/:section',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
                trans.params(),
            deps: [Transition],
        }
    ]

};

export const userguideSectionPageState: Ng2StateDeclaration = {
    name: 'userGuide.section.page',
    url: '/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
                trans.params(),
            deps: [Transition],
        }
    ]
};

export const userguideSubsectionHomeState: Ng2StateDeclaration = {
    name: 'userGuide.section.subsection',
    url: '/:subsection',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
                trans.params(),
            deps: [Transition],
        }
    ]
};

export const userguideSubsectionPageState: Ng2StateDeclaration = {
    name: 'userGuide.section.subsection.page',
    url: '/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'transitionParams',
            resolveFn: (trans: Transition) =>
            trans.params(),
            deps: [Transition],
        }
    ]
};


/*
export const userguideHomeState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuide',
    url: '/userguide',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath',
            resolveFn: () => '/index.html',
            deps: [],
        }
    ]
};

export const userguideHomePageState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuidePage',
    url: '/userguide/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath',
            resolveFn: (trans: Transition) =>
                `/${trans.params().page}`,
            deps: [Transition],
        }
    ]
};

export const userguideSectionHomeState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuideSection',
    url: '/userguide/:section',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath',
            resolveFn: (trans: Transition) =>
                `/${trans.params().section}/index.html`,
            deps: [Transition],
        }
    ]
};

export const userguideSectionPageState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuideSectionPage',
    url: '/userguide/:section/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath',
            resolveFn: (trans: Transition) =>
                `/${trans.params().section}/${trans.params().page}.html`,
            deps: [Transition],
        }
    ]
};

export const userguideSubsectionHomeState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuideSectionSubsection',
    url: '/userguide/:section/:subsection',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath',
            resolveFn: (trans: Transition) =>
                `/${trans.params().section}/${trans.params().subsection}/index.html`,
            deps: [Transition],
        }
    ]
};

export const userguideSubsectionPageState: Ng2StateDeclaration = {
    parent: 'app',
    name: 'userGuideSectionSubsectionPage',
    url: '/userguide/:section/:subsection/:page',
    component: UserGuideComponent,
    resolve: [
        {
            token: 'contentPath2',
            resolveFn: (trans: Transition) =>
                `/${trans.params().section}/${trans.params().subsection}/${trans.params().page}.html`,
            deps: [Transition],
        }
    ]
};
*/

export const USERGUIDE_STATES = [
    userguideHomeState,
    userguideHomePageState,
    
    userguideSectionHomeState,
    userguideSectionPageState,

    userguideSubsectionHomeState,
    userguideSubsectionPageState,       
];
